import API from 'services/API/index';
import { moment } from 'utils';
import sortMessageHistory from '../../utils/sortMessageHistory';

const ERRORS_SEPARATOR = '|';

export default function messages() {
  return API.request({
    method: 'GET',
    url: `/notification/all`,
    mapper: function (data) {
      return data
        .map((message) => {
          const historyArray = message.history || [];

          message.history = historyArray
            .map((history) => {
              history.date = moment.fromServerFullDatetime(history.notificationDateTime);

              if (
                history.notificationMessage &&
                ~history.notificationMessage.indexOf(ERRORS_SEPARATOR)
              ) {
                const parsedMessage = parseMessage(history.notificationMessage);

                history.notificationMessage = parsedMessage.message;
                history.errors = parsedMessage.errors;
              }

              return history;
            })
            .sort(sortMessageHistory);

          message.date = message.notificationDateTime
            ? moment.fromServerFullDatetime(message.notificationDateTime)
            : (message.history[0] || {}).notificationDateTime;
          message.status = message.history[0] ? message.history[0].status : null;

          return message;
        })
        .sort((m1, m2) => {
          if (m1.isRead !== m2.isRead) {
            return m1.isRead ? 1 : -1;
          }

          return m1.date.isBefore(m2.date) ? 1 : -1;
        });
    },
  });
}

function parseMessage(message) {
  const messageArray = message.split(ERRORS_SEPARATOR);

  return {
    message: messageArray.shift(),
    errors: messageArray,
  };
}
